import { Component, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Title, Meta } from '@angular/platform-browser';
import { MenuEnum } from 'src/app/shared/enum/menu-enum';
import { CasesSubMenuEnum } from 'src/app/shared/enum/cases-submenu-enum';
import { HeaderService } from 'src/app/core/services/header.service';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
  selector: 'app-case-generali',
  templateUrl: './case-generali.component.html',
  styleUrls: ['./case-generali.component.scss']
})

export class CaseGeneraliComponent implements OnInit {
  data: any;

  constructor(
    private translate: TranslateService,
    private headerService: HeaderService,
    private titleService: Title,
    private meta: Meta,
    private router: Router,
    private gaService: GoogleAnalyticsService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.carregarDados();
    });
  }

  ngOnInit() {
    this.headerService.carregarSubMenu(MenuEnum.CASES, CasesSubMenuEnum.GENERALI);
    this.carregarDados();
  }

  carregarDados() {
    this.translate.get('PRINCIPAL.PAGES.CASES.PAGES.GENERALI')
      .subscribe(res => {
        this.data = res;
        this.titleService.setTitle(this.data.HEADER_TITLE);
        this.meta.updateTag({ name: 'description', content: this.data.META_DESCRIPTION });
        this.meta.updateTag({ name: 'keywords', content: this.data.META_KEYWORDS });
        this.gaService.pageView(this.router.url);
      });
  }

}
